// 9fbef606107a605d69c0edbcd8029e5d

const drawDefault = (ctx) => {
  ctx.beginPath();
  for (let i = 0; i < 22; i += 1) {
    const angle = 0.35 * i;
    const x = (0.2 + 1.5 * angle) * Math.cos(angle);
    const y = (0.2 + 1.5 * angle) * Math.sin(angle);
    ctx.lineTo(x, y);
  }
  ctx.stroke();
  ctx.closePath();
};

export default drawDefault;
